import {createContext} from 'react';
import {Breadcrumb} from './types';

export type BreadcrumbContextValue = (breadcrumbs: Breadcrumb[]) => void;

const BreadcrumbContext = createContext<BreadcrumbContextValue>(breadcrumbs => void breadcrumbs);

export default BreadcrumbContext;
